import axios from "axios";
import { osName, browserName, deviceType } from "mobile-device-detect";

export default function SlackAlert(domain, uid, errCode, reason) {
    const params = new URLSearchParams(window.location.search);
    
    if (params.get("alert") === "false") {
        return;
    }

    const message = (err) => {
        axios.post(
            `${process.env.REACT_APP_API_ENDPOINT ?? '/'}api/trigger-alert`,
            {
                url: window.location.href,
                errCode,
                domain,
                userAgent: {
                    os: osName,
                    browser: browserName,
                    device: deviceType ?? 'Desktop'
                },
                timestamp: new Date().toISOString(),
                reason: err ? (err.message || JSON.stringify(err)) : undefined,
                uid
            }
        ).catch((err)=>{console.log(err);})
    };

    axios
    .get(`${domain}/api/qr-code?uId=${uid}`)
    .then((result) => {
        if(result.status !== 200){
            message(new Error(`Unexpected status: ${result.status}`));
        }
    })
    .catch((err) => {
        message(err);
    });
}